module.exports = __webpack_public_path__ + "img/group.dbdab68b.png";